// 47 Telegram Official Categories with colors
export const TELEGRAM_CATEGORIES = [
  { id: 'news_media', name_en: 'News and Media', name_ar: 'الأخبار والإعلام', color: '#FF6B6B' },
  { id: 'blogs', name_en: 'Blogs', name_ar: 'المدونات', color: '#4ECDC4' },
  { id: 'humor_entertainment', name_en: 'Humor and Entertainment', name_ar: 'الفكاهة والترفيه', color: '#45B7D1' },
  { id: 'technologies', name_en: 'Technologies', name_ar: 'التكنولوجيا', color: '#96CEB4' },
  { id: 'economics', name_en: 'Economics', name_ar: 'الاقتصاد', color: '#FFEAA7' },
  { id: 'business_startups', name_en: 'Business and Startups', name_ar: 'الأعمال والشركات الناشئة', color: '#DDA0DD' },
  { id: 'cryptocurrencies', name_en: 'Cryptocurrencies', name_ar: 'العملات الرقمية', color: '#98D8C8' },
  { id: 'travel', name_en: 'Travel', name_ar: 'السفر والسياحة', color: '#F7DC6F' },
  { id: 'marketing_pr', name_en: 'Marketing, PR, Advertising', name_ar: 'التسويق والإعلان', color: '#BB8FCE' },
  { id: 'psychology', name_en: 'Psychology', name_ar: 'علم النفس', color: '#85C1E9' },
  { id: 'design', name_en: 'Design', name_ar: 'التصميم', color: '#F8B500' },
  { id: 'politics', name_en: 'Politics', name_ar: 'السياسة', color: '#00CED1' },
  { id: 'art', name_en: 'Art', name_ar: 'الفن', color: '#FF69B4' },
  { id: 'law', name_en: 'Law', name_ar: 'القانون', color: '#32CD32' },
  { id: 'education', name_en: 'Education', name_ar: 'التعليم', color: '#FFD700' },
  { id: 'books', name_en: 'Books', name_ar: 'الكتب', color: '#FF4500' },
  { id: 'linguistics', name_en: 'Linguistics', name_ar: 'اللغويات', color: '#1E90FF' },
  { id: 'career', name_en: 'Career', name_ar: 'الوظائف والمهن', color: '#00FA9A' },
  { id: 'edutainment', name_en: 'Edutainment', name_ar: 'الترفيه التعليمي', color: '#FF1493' },
  { id: 'courses_guides', name_en: 'Courses and Guides', name_ar: 'الدورات والأدلة', color: '#00BFFF' },
  { id: 'sport', name_en: 'Sport', name_ar: 'الرياضة', color: '#ADFF2F' },
  { id: 'fashion_beauty', name_en: 'Fashion and Beauty', name_ar: 'الموضة والجمال', color: '#FF6347' },
  { id: 'medicine', name_en: 'Medicine', name_ar: 'الطب', color: '#7B68EE' },
  { id: 'health_fitness', name_en: 'Health and Fitness', name_ar: 'الصحة واللياقة', color: '#00FF7F' },
  { id: 'pictures_photos', name_en: 'Pictures and Photos', name_ar: 'الصور والتصوير', color: '#DC143C' },
  { id: 'software_apps', name_en: 'Software & Applications', name_ar: 'البرامج والتطبيقات', color: '#00FFFF' },
  { id: 'video_films', name_en: 'Video and Films', name_ar: 'الفيديو والأفلام', color: '#FF00FF' },
  { id: 'music', name_en: 'Music', name_ar: 'الموسيقى', color: '#FFFF00' },
  { id: 'games', name_en: 'Games', name_ar: 'الألعاب', color: '#FF8C00' },
  { id: 'food_cooking', name_en: 'Food and Cooking', name_ar: 'الطعام والطبخ', color: '#9370DB' },
  { id: 'quotes', name_en: 'Quotes', name_ar: 'الاقتباسات', color: '#3CB371' },
  { id: 'handiwork', name_en: 'Handiwork', name_ar: 'الأعمال اليدوية', color: '#FA8072' },
  { id: 'family_children', name_en: 'Family & Children', name_ar: 'الأسرة والأطفال', color: '#87CEEB' },
  { id: 'nature', name_en: 'Nature', name_ar: 'الطبيعة', color: '#DEB887' },
  { id: 'interior_construction', name_en: 'Interior and Construction', name_ar: 'الديكور والبناء', color: '#5F9EA0' },
  { id: 'telegram', name_en: 'Telegram', name_ar: 'تيليجرام', color: '#D2691E' },
  { id: 'instagram', name_en: 'Instagram', name_ar: 'انستجرام', color: '#6495ED' },
  { id: 'sales', name_en: 'Sales', name_ar: 'المبيعات', color: '#FFC0CB' },
  { id: 'transport', name_en: 'Transport', name_ar: 'النقل والمواصلات', color: '#B0E0E6' },
  { id: 'religion', name_en: 'Religion', name_ar: 'الدين', color: '#CD853F' },
  { id: 'esoterics', name_en: 'Esoterics', name_ar: 'الروحانيات', color: '#48D1CC' },
  { id: 'real_estate', name_en: 'Real Estate', name_ar: 'العقارات', color: '#C71585' },
  { id: 'automotive', name_en: 'Automotive', name_ar: 'السيارات', color: '#40E0D0' },
  { id: 'pets_animals', name_en: 'Pets & Animals', name_ar: 'الحيوانات الأليفة', color: '#EE82EE' },
  { id: 'science', name_en: 'Science', name_ar: 'العلوم', color: '#F5DEB3' },
  { id: 'history', name_en: 'History', name_ar: 'التاريخ', color: '#9ACD32' },
  { id: 'other', name_en: 'Other', name_ar: 'أخرى', color: '#E6E6FA' }
];

// Get category by ID
export const getCategoryById = (id) => {
  return TELEGRAM_CATEGORIES.find(cat => cat.id === id);
};

// Get category color by ID
export const getCategoryColor = (id) => {
  const category = getCategoryById(id);
  return category?.color || '#808080';
};

// Get category name by ID and language
export const getCategoryName = (id, isArabic = false) => {
  const category = getCategoryById(id);
  if (!category) return id;
  return isArabic ? category.name_ar : category.name_en;
};
